export function CreateCurveIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Create new Curve"
    >
      <path
        d="M8.76169 1.65253C8.76169 1.23031 8.42201 0.890625 7.99978 0.890625C7.57756 0.890625 7.23788 1.23031 7.23788 1.65253V7.23983H1.65058C1.22835 7.23983 0.888672 7.57951 0.888672 8.00174C0.888672 8.42396 1.22835 8.76364 1.65058 8.76364H7.23788V14.3509C7.23788 14.7732 7.57756 15.1128 7.99978 15.1128C8.42201 15.1128 8.76169 14.7732 8.76169 14.3509V8.76364H14.349C14.7712 8.76364 15.1109 8.42396 15.1109 8.00174C15.1109 7.57951 14.7712 7.23983 14.349 7.23983H8.76169V1.65253Z"
        fill="currentColor"
      />
    </svg>
  );
}
